import { Component } from '@angular/core';

@Component({
  selector: 'haawai-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'labeling-tool';
}
